import { Pipe, PipeTransform } from '@angular/core';

import { t, TranslationKey } from '@lib/translation';

@Pipe({
  name: 'colorNameTranslation',
  pure: true
})
export class ColorNameTranslationPipe implements PipeTransform {
  constructor() {}

  transform(colorKey: string): string {
    if (!colorKey) {
      return '';
    }
    
    const translationKey = colorKey.replace(/-/g, '').toLowerCase();
    return t(`common.colors.${translationKey}` as TranslationKey);
  }
}
